<template>
  <brazil-field
    :label="label"
    :validator-field="validatorField"
  >
    <div class="btn-group">
      <label
        v-for="option in options"
        :key="option.id"
        :style="inlineStyle"
      >
        {{ option.label }}
        <input
          :id="option.id"
          v-model="validatorField.$model"
          :value="option.value"
          :name="name"
          type="radio"
          :autocomplete="autocomplete"
          :class="status"
          :disabled="disabled"
        >
      </label>
    </div>
  </brazil-field>
</template>
<script>
import safeGet from '../../store/pathifyUtilities';
import BrazilField from './BrazilField.vue';

export default {
  components: {
    BrazilField,
  },
  props: {
    name: {
      type:     String,
      required: true,
    },
    label: {
      type:     String,
      required: true,
    },
    validatorField: {
      type:     Object,
      required: true,
    },
    options: {
      type:     Array,
      required: true,
    },
    autocomplete: {
      type:    String,
      default: null,
    },
    inline: {
      type:    Boolean,
      default: true,
    },
  },
  computed: {
    status() {
      return {
        valid: this.validatorField.$dirty && !this.validatorField.$error,
        error: this.validatorField.$error,
      };
    },
    disabledFields: safeGet('registration/disabledFieldNames', []),
    disabled() {
      return this.disabledFields.includes(this.name);
    },
    inlineStyle() {
      return this.inline ? 'display: inline;' : 'display: block;';
    },
  },
};
</script>
<style scoped>
label {
  color: #333333 !important;
}
</style>
